import { useTranslation } from "react-i18next";
import "./SecondaryInfoCard.css";
import purposeIcon from "../../../../../assets/brand/meta.png";
import volunteeringIcon from "../../../../../assets/brand/volonteer.png";
import principlesIcon from "../../../../../assets/brand/cinnosti.png";

const ICONS = {
  purpose: purposeIcon,
  volunteering: volunteeringIcon,
  principles: principlesIcon,
};

const CARD_NUMBERS = {
  purpose: "01",
  volunteering: "02",
  principles: "03",
};

export default function SecondaryInfoCard({ children, title, type = "purpose" }) {
  const { t } = useTranslation("translation", { keyPrefix: "main" });
  const icon = ICONS[type] || purposeIcon;

  return (
    <article className={`main__secondary-info__card main__secondary-info__card--${type}`}>
      <div className="main__secondary-info__card__header">
        <div className="main__secondary-info__card__icon" aria-hidden="true">
          <img src={icon} alt="" />
        </div>
        <div>
          <span className="main__secondary-info__card__number">{CARD_NUMBERS[type]}</span>
          <p className="main__secondary-info__card__title">{t(title)}</p>
        </div>
      </div>
      <div className="main__secondary-info__card__body">{children}</div>
    </article>
  );
}
